module.exports = __webpack_public_path__ + "media/msg.da4e2c54.mp3";